import * as models from '@/class/models/views/setting/users';

export const STORAGE_KEY_SIDEBAR = 'labor-management/sideBarInfo';

/**
 * サイドバーのリスト開閉情報と選択情報
 * localstorageによる管理を行う
 */
export interface SideBarInfo {
    departments: models.IDepartmentInfo[];
    selectedDepartmentID: number;
    selectedUserID: number;
}

/**
 * 管轄のユーザーリストから所属部署のリストを取得する
 * @return 所属部署リスト
 */
export function GetUsingDepartmentsList(usersList: models.IUser[], departmentsList: models.IDepartmentInfo[]): models.IDepartmentInfo[] {
    const usingDepartmentSet = new Set<number>();
    // ユーザーがいる部署を抽出
    usersList.forEach(user => {
        if (!usingDepartmentSet.has(user.departmentID)) {
            usingDepartmentSet.add(user.departmentID);
        }
    });
    // ユーザーがいる子部署の親部署を抽出
    departmentsList.forEach(d => {
        if (usingDepartmentSet.has(d.departmentID) && !usingDepartmentSet.has(d.parentID)) {
            usingDepartmentSet.add(d.parentID);
        }
    });

    return departmentsList.filter(d => usingDepartmentSet.has(d.departmentID));
}

/**
 * サイドバー情報を正規化した上で返す。
 * @returns SideBarInfoを返す。
 */
export function loadValidSideBarInfo(usersList: models.IUser[], departmentsList: models.IDepartmentInfo[]): SideBarInfo {
    let sideBarInfo = loadSideBarInfo();
    let initSelect = false;

    if (!sideBarInfo) {
        sideBarInfo = {
            departments: departmentsList,
            selectedDepartmentID: -1,
            selectedUserID: -1,
        };
        initSelect = true;
    } else if (
        !usersList.some(v => v.userID === sideBarInfo.selectedUserID) &&
        sideBarInfo.selectedDepartmentID === -1
    ) {
        initSelect = true;
    } else if (
        !departmentsList.some(v => v.departmentID === sideBarInfo.selectedDepartmentID) &&
        sideBarInfo.selectedUserID === -1
    ) {
        initSelect = true;
    }

    if (initSelect) {
        sideBarInfo.selectedDepartmentID = -1;
        sideBarInfo.selectedUserID = -1;

        if (usersList.length > 0) {
            const initialUser = usersList[0];
            sideBarInfo.selectedUserID = initialUser.userID;
        }
    }
    sideBarInfo.departments = copySideBarClosed(departmentsList, sideBarInfo.departments);

    return sideBarInfo;
}

/**
 * サイドバーの開閉状態をnewDepartmentsに反映する
 * @returns IDepartmentInfo[]を返す。
 */
export function copySideBarClosed(newDeps: models.IDepartmentInfo[], oldDeps: models.IDepartmentInfo[]) {
    const closedIds = new Set(
        oldDeps.filter(v => v.isClosed).map(v => v.departmentID),
    );

    return newDeps.map(dep => ({
         ...dep,
         isClosed: closedIds.has(dep.departmentID),
    }));
}

/**
 * サイドバー情報をlocalstorageで取得
 * @returns SideBarInfoを返すが、破損やデータがない場合はundefinedを返す
 */
export function loadSideBarInfo(): SideBarInfo | undefined {
    const savedData = localStorage.getItem(STORAGE_KEY_SIDEBAR);

    if (!savedData) { return undefined; }

    try {
      return JSON.parse(savedData) as SideBarInfo;
    } catch (error) {
      console.error('Failed to parse SideBarInfo:', error);
      return undefined;
    }
}

/**
 * サイドバー情報をlocalstorageで保存する
 * @returns 成功の有無
 */
export function saveSideBarInfo(sideBarInfo: SideBarInfo) {
    try {
        localStorage.setItem(STORAGE_KEY_SIDEBAR, JSON.stringify(sideBarInfo));
        return true;
    } catch (error) {
        console.error('Failed to setItem SideBarInfo:', error);
        return false;
    }
}
